import { ApiRateLimitType } from "src/shared/types/src";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RateLimitActions } from "./RateLimitSlice";

export const setRateLimitConfig = createAsyncThunk(
    "setRateLimitConfig", async ({ isRateLimitActive, retryAfter }: ApiRateLimitType , { dispatch }) => {
        try {
            await dispatch(RateLimitActions.setRateLimitConfig({
                isRateLimitActive,
                retryAfter
            }));
        } catch (error) {
            await dispatch(RateLimitActions.resetRateLimitConfig());
            console.log("error in setting rate limit config options: ", error, (error as any).response);
        }
    }
);